import * as hostedPayment from './membership-hostedPayment'
import * as donationAmounts from './donation-amounts'
import './membership-level-groups';
import { LabeledCardNumber } from '../../modules/labeled-card-number';

// Mark donor name as disabled if the "anonymous" checkbox is checked
const anonymousCheckbox = document.querySelector('input[type="checkbox"][data-anonymous-checkbox]') as HTMLInputElement;
const donorNameField = document.querySelector('[data-donor-name]') as HTMLInputElement;

anonymousCheckbox?.addEventListener('change', () => {
    if ((anonymousCheckbox).checked) {
        donorNameField.setAttribute('disabled', 'disabled');
        donorNameField.value = '';
    }
    else {
        donorNameField.removeAttribute('disabled');
    }
});

const cardNumberFormItem = document.querySelector('[data-labeled-card-number]') as HTMLElement;
if (cardNumberFormItem) {
    new LabeledCardNumber(cardNumberFormItem);
}

donationAmounts.initializeAmounts();
hostedPayment.initializePayment();